import React, {useEffect, useRef, useState} from 'react';
import axios from '../../services/axiosInstance';
import '../../css/web/AdminSwichingPg.css';

import maCateImg from "../../assets/img/m-a-cate.png";

function AdminSwichingPg() {

    const SSAT = sessionStorage.getItem('adminToken');
    const LCAT = localStorage.getItem('adminToken');

    const [adminInfo, setAdminInfo] = useState([]);

    const selectAdminInfo = (() => {
        axios({
            method: 'get',
            url: '/member/modiInfo',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response)=> {
                setAdminInfo(response.data[0])
            })
            .catch(()=> {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        selectAdminInfo();
        selectedSwicing();
    }, [])

    const [workingFl, setWorkingFl] = useState(false);
    const [cnyFl, setCnyFl] = useState(false);
    const [showFl, setShowFl] = useState(false);
    const selectedSwicing = () => {
        try {
            axios({
                method: 'get',
                url: '/swiching/selectedSwicing',
                withCredentials: true
            }).then((res) => {
                const data = res.data;
                setWorkingFl(data.workingFl);
                setCnyFl(data.cnyFl);
                setShowFl(data.showFl);
            })
        } catch (err) {
            console.log("업무현황여부 조회실패")
        }
    }

    const updateSwichingFl = (type, value) => {
        axios.post(`/swiching/updateSwichingFl`, null, {
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: { type, value },
            withCredentials: true
        }).then(() => {
            if (type === 'work') setWorkingFl(value);
            if (type === 'cny') setCnyFl(value);
            if (type === 'show') setShowFl(value);
        }).catch(err => console.log('스위칭 업데이트 실패', err));
    };











    return (
        <div className="AdminEmployeeInfoPg font-t-cont">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">스위칭관리</p>
            </div>

            <div className="admin-wrap">
                <div className="admin-wrap-card full-transfer-card switch-dashboard">

                    {/* 카드 스타일 */}
                    <div className="switch-card-container">

                        {/* 업무시간 */}
                        <div className="switch-card">
                            <h3 className="switch-title">업무시간 스위칭</h3>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={workingFl}
                                    onChange={() => updateSwichingFl('work', !workingFl)}
                                />
                                <span className={`slider round ${workingFl ? 'on' : 'off'}`}>
                                    <span className="switch-text">{workingFl ? "OPEN" : "CLOSE"}</span>
                                </span>
                            </label>
                        </div>

                        {/* 위안화 */}
                        <div className="switch-card">
                            <h3 className="switch-title">위안화 스위칭</h3>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={cnyFl}
                                    onChange={() => updateSwichingFl('cny', !cnyFl)}
                                />
                                <span className={`slider round ${cnyFl ? 'on' : 'off'}`}>
                                    <span className="switch-text">{cnyFl ? "OPEN" : "CLOSE"}</span>
                                </span>
                            </label>
                        </div>

                        {/* 조건뷰 스위칭(앱스토어 심사 시 Close) */}
                        <div className="switch-card">
                            <h3 className="switch-title">조건뷰 스위칭</h3>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={showFl}
                                    onChange={() => updateSwichingFl('show', !showFl)}
                                />
                                <span className={`slider round ${showFl ? 'on' : 'off'}`}>
                                    <span className="switch-text">{showFl ? "OPEN" : "CLOSE"}</span>
                                </span>
                            </label>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminSwichingPg
